<div class="modal-overlay" (click)="onCancel()">
    <div class="modal-section" (click)="$event.stopPropagation()">
        <div class="add-new-wrapper">
            <div class="header new-section-header">
                <h3>{{ "DATA_MODEL_CUSTOMIZATION.SECTION_NAME" | translate }}</h3>
                <h5>Give this section a name</h5>
            </div>
            <div class="body">
                <label>
                    <input [(ngModel)]="name" type="text" [placeholder]="'CRUD.NAME' | translate " />
                </label>
            </div>
            <div class="footer">
                <button (click)="onCancel()">{{ "CRUD.CANCEL" | translate }}</button>
                <button (click)="save()" class="save-btn">{{ "CRUD.SAVE" | translate }}</button>
            </div>
        </div>
    </div>
</div>